export const prevent = (ev: any) => {
  ev.stopPropagation()
  ev.preventDefault()
}